import {LazyAsync, RestClient} from "zavadil-ts-common";
import {ContactSource} from "../../types/ContactSource";

export class ContactSourcesClient {

	client: RestClient;

	lazy: LazyAsync<Array<ContactSource>>;

	constructor(client: RestClient) {
		this.client = client;

		this.lazy = new LazyAsync(() => this.client.getJson('contact-source/all'));
	}

	all(): Promise<Array<ContactSource>> {
		return this.lazy.get();
	}

}
